import { render, staticRenderFns } from "./DeleteLiteracyBadgeConfirmationDialog.vue?vue&type=template&id=f990aad0"
import script from "./DeleteLiteracyBadgeConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteLiteracyBadgeConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports